import axios from "axios";
import {Link} from 'react-router-dom';
import {useState,useEffect, useContext} from 'react';
import './MyStyles.css';
import Badge from '@mui/material/Badge';
import MailIcon from '@mui/icons-material/Mail';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAuth } from '../context/AuthContext';

import {baseUrl, userLocation, ipAddress, userName} from './Univ.js'
const formatDateTime = (dateTimeString) => {
      return new Date(dateTimeString).toLocaleString('en-IN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    };
function Header(props) {
  const [searchString, setsearchString] = useState({ search: '' });
  const { logoutUser, user } = useAuth();
  const checkUser = localStorage.getItem('user_login');
  const checkPat = localStorage.getItem('pat_login');
  const pat_id = localStorage.getItem('pat_id');
  const userGroup = localStorage.getItem('userGroup');
  const [tasks, setTasks] = useState([]);
    const [unreadTasks, setUnreadTasks] = useState([]);

  const handleLogout = () => {
    logoutUser();
    window.location.href = '/user-login/';
  };
  const linkMap = {
    FrontOffice: {
      home: '/front-menu/',
      menu: '/admin-menu',
    },
    Admin: {
      home: '/admin-menu',
      menu: '/',
    },
    Lab: {
      home: '/lab-view/',
      menu: '/admin-menu',
    },
    Radiology: {
      home: '/lab-view/',
      menu: '/admin-menu',
    },
  };
  const links = linkMap[userGroup] || {};

  const handlePatLogout = () => {
    localStorage.removeItem('pat_login');
    localStorage.removeItem('pat_id');
    localStorage.removeItem('group');
    window.location.href = '/patient-login/';
  };

  const handleChange = (event) => {
    setsearchString({
      ...searchString,
      [event.target.name]: event.target.value,
    });
  };
   const taskUser= tasks.map(row => row.addedby);
     useEffect(() => {
    // Update unread tasks whenever tasks change
        setUnreadTasks(tasks.filter(row => row.status === 1 && row.addedby === userName));
      }, [tasks, userName]);

    const countUnreadTasks = unreadTasks.length;

   const badgeColor = countUnreadTasks > 0 ? 'warning' : 'default';
  const iconColor = countUnreadTasks > 0 ? 'error' : 'action';
const badgeStyle = {
    animation: countUnreadTasks > 0 ? 'blink 1s infinite' : 'none',
  };

  const iconStyle = {
    animation: countUnreadTasks > 0 ? 'blink 1s infinite' : 'none',
  };

  const searchCourse = () => {
    if (searchString.search !== '') {
      window.location.href = '/emr-details/' + searchString.search;
    }
  };

return (
    <nav className="navbar navbar-expand-lg navbar-dark custom-navbar">
      <div className="container">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo01"
          aria-controls="navbarTogglerDemo01"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
          {/* Render content for users */}
          {checkUser === 'true' && (
            <>
              <Link className="navbar-brand" aria-current="page" to={links.menu}>
                MGM DrG HIS
              </Link>
              <form className="d-flex">
                <input
                  name="search"
                  onChange={handleChange}
                  className="form-control me-2"
                  type="search"
                  placeholder="Search by Patient ID for EMR"
                  aria-label="Search"
                />
                <button
                  onClick={searchCourse}
                  className="btn btn-info"
                  type="button"
                >
                  Search
                </button>
              </form>
              <ul className="navbar-nav ms-auto  mb-lg-0 d-flex align-items-center">
                <li className="nav-item">
                  <Link className="navbar-brand" aria-current="page" to={links.home}>
                  <FontAwesomeIcon icon="fa-solid fa-house-user" size="1x" color="#ffc107" />
                  </Link>
                </li>
                <li className="nav-item">
                <style>
                    {`
                      @keyframes blink {
                        0% { opacity: 1; }
                        50% { opacity: 0; }
                        100% { opacity: 1; }
                      }
                    `}
                  </style>

                </li>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {userName}
                  </a>
                  <ul className="dropdown-menu">
                    <li className="dropdown-item">Welcome: {userName}</li>
                    <li>
                      <Link className="dropdown-item" to={links.menu}>
                        Menu
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/change-password">
                            Change Password
                        </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="#" onClick={handleLogout}>
                        Logout
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </>
          )}

          {/* Render content for patients */}
          {checkPat === 'true' && userGroup === 'Patient' && (
            <>
              <Link className="navbar-brand" aria-current="page" to="/">
                MGM DrG  HIMS
              </Link>
              <ul className="navbar-nav ms-auto mb-4 mb-lg-0">
                <li className="nav-item">
                  <Link className="nav-link" aria-current="page" to="/pat-menu">
                    Home
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {pat_id}
                  </a>
                  <ul className="dropdown-menu">
                    <li className="dropdown-item">Welcome: {pat_id}</li>
                    <li>
                      <Link className="dropdown-item" to="/">
                        Dashboard
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="#" onClick={handlePatLogout}>
                        Logout
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </>
          )}

          {/* Render content for both users and patients */}
          {!checkUser && !checkPat && (
            <h3 style={{ color: 'white', textAlign: 'center' }}>
              MGM DrG HIMS
            </h3>
          )}
        </div>
      </div>
    </nav>
  );
}

export { formatDateTime };
export default Header;